<template>
  <div>
    <PageMain
      ref="main"
      :loading="loading"
      :tableData="tableData"
      :disabled="disabled"
      :show-footer="inProgress"
      @reload="init()"
      @edit-reload="$emit('reload')"
      @change-detail="changeDetail"
    >
      <template #header>
        <div class="d-flex align-items-stretch">
          <div class="side-frame"></div>
          <div class="d-flex align-items-center">
            <span style="font-size: 14px; color: #606266">
              {{ $l('table_header_title_sku') || '订单产品明细' }}
            </span>
          </div>
        </div>
      </template>
    </PageMain>

    <ChangeForm
      :visible.sync="changeFromOpts.visible"
      :amzPurchaseChangeCode="amzPurchaseChangeCode"
      :amzPurchaseDetailCode="changeFromOpts.amzPurchaseDetailCode"
      :changeType="changeFromOpts.changeType"
      :changeFields="changeFromOpts.changeFields"
      :optType="changeFromOpts.optType"
      @reload="init()"
    />
  </div>
</template>
<script>
import PageMain from './main'
import ChangeForm from '../change-form'
import EditLoading from '@/mixins/edit-loading'
import { multiply, divide } from '@/libs/util.number.js'
export default {
  components: { PageMain, ChangeForm },
  mixins: [EditLoading],
  props: {
    disabled: { type: Boolean, default: false },
    amzPurchaseChangeCode: { type: String, default: '' },
    approvalStatus: { type: String, default: 'N' },
  },
  data() {
    return {
      tableData: [],
      loading: false,
      changeFromOpts: {
        visible: false,
        amzPurchaseDetailCode: '',
        changeType: '',
        changeFields: [],
        optType: '',
      },
    }
  },
  computed: {
    inProgress() {
      return ['N', 'R', 'S'].includes(this.approvalStatus)
    },
  },
  methods: {
    async init() {
      if (this.inProgress) return this.getData()
      this.getChangeRecord()
    },
    async getData() {
      if (!this.amzPurchaseChangeCode) return
      this.loading = true
      const params = { amzPurchaseChangeCode: this.amzPurchaseChangeCode }
      const res = await this.$api
        .ecomAmzFtyPurchaseChangeDetailsApi(params)
        .catch(() => null)
      this.loading = false
      const data = res?.body?.data || []

      this.tableData = this._dataTransform(data)
    },
    async getChangeRecord() {
      if (!this.amzPurchaseChangeCode) return

      this.loading = true
      const params = { amzPurchaseChangeCode: this.amzPurchaseChangeCode }
      const res = await this.$api
        .ecomAmzFtyPurchaseChangeRecordApi(params)
        .catch(() => null)
      this.loading = false
      const data = (res?.body?.data || [])
        .map((item) => {
          const { objectData, ...changeRecord } = item
          if (!objectData) return
          const row = JSON.parse(objectData)
          return { ...row, changeRecord }
        })
        .filter(Boolean)

      const tableData = this._dataTransform(data)
      this.tableData = tableData.sort((a, b) => {
        if (a.seqno === b.seqno) {
          return a.changeIndex - b.changeIndex
        }
        return a.seqno - b.seqno
      })
    },
    _dataTransform(data) {
      return data
        .map(({ changeRecord, ...row }) => {
          if (!changeRecord) return [row]

          const {
            inCtnQty,
            purchaseQty,
            ctnQty,
            purchasePrice,
            subAmount,
            actualDeliveryDate,
            shippedQty,
            invQty,
            seqno,
            shortageQuantity,
          } = row
          const { changeType, objectCode, fieldList } = changeRecord

          const changeNewValue = (fieldList || []).reduce((r, n) => {
            r[n.fieldName] = n.fieldNewValue
            return r
          }, {})
          const changeOldValue = (fieldList || []).reduce((r, n) => {
            r[n.fieldName] = n.fieldOldValue
            return r
          }, {})

          const originRow = {
            ...row,
            ...changeOldValue,
            isChange: true,
            changeType,
            changeIndex: 1,
          }
          originRow.invQty = originRow.purchaseQty - originRow.shippedQty - originRow.shortageQuantity
          originRow.subAmount = multiply(
            originRow.purchasePrice,
            originRow.purchaseQty
          )
          originRow.ctnQty = divide(originRow.purchaseQty, originRow.inCtnQty)

          const newRow = {
            changeType,
            inCtnQty,
            purchaseQty,
            ctnQty,
            purchasePrice,
            subAmount,
            actualDeliveryDate,
            shippedQty,
            invQty,
            ...changeNewValue,
            amzPurchaseDetailCode: objectCode,
            isNew: true,
            originRow,
            oldRow: {},
            seqno,
            changeIndex: 2,
            shortageQuantity
          }
          newRow.invQty = newRow.purchaseQty - newRow.shippedQty- newRow.shortageQuantity
          newRow.subAmount = multiply(newRow.purchasePrice, newRow.purchaseQty)
          newRow.ctnQty = divide(newRow.purchaseQty, newRow.inCtnQty)
          newRow.oldRow = { ...newRow, ...changeNewValue }
          return [originRow, newRow]
        })
        .reduce((r, n) => {
          r.push(...n)
          return r
        }, [])
    },
    changeDetail({
      amzPurchaseDetailCode,
      changeType,
      changeFields = [],
      optType = 'detail',
    }) {
      this.changeFromOpts = {
        visible: true,
        amzPurchaseDetailCode,
        changeType,
        changeFields,
        optType,
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame {
  padding: 1px 5px;
  border-left: 3px solid $color-primary;
  margin-top: 3px;
  margin-bottom: 3px;
}
</style>
